import { RHFTextField } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box, InputLabel } from '@mui/material';
import { createElement, memo } from 'react';
import * as SX from './sx';
import type { BillingInformationInputProps as Props } from './types';

export const BillingInformationInput = memo(
  ({
    className,
    name,
    label,
    size = 'small',
    element = RHFTextField,
    extra,
  }: Props) => {
    return (
      <Box
        className={classnames('BillingInformationInput', className)}
        sx={{ display: 'flex', flexDirection: 'column' }}
      >
        <InputLabel shrink htmlFor={name} sx={SX.label}>
          {label}
        </InputLabel>
        {createElement(element, { ...extra, name, size })}
      </Box>
    );
  }
);

BillingInformationInput.displayName = 'BillingInformationInput';
